export default "__VITE_ASSET__Gfk2$t3o__"